// Theme: aurora
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'aurora',
  name: 'AURORA',
  tagline: 'AURORA',
  description: 'Aurora boreal classica com ceu azul e cortinas verdes.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 2200,
  swatches: ['#04172B', '#0C2942', '#61F2A4', '#E3F9FF'],
  baseStyle: {
    cardClasses: 'glass-panel',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 14px 36px color-mix(in srgb, var(--primary) 10%, transparent)',
      '--shadow-card-active': '0 16px 40px color-mix(in srgb, var(--primary) 12%, transparent)'
    },
    shellClasses: 'font-mono theme-aurora'
  },
  colorVars: {
    '--accent': '#6ACBFF',
    '--accent-foreground': '#04172B',
    '--background': '#04172B',
    '--border': '#1E4B6E',
    '--card': '#0C2942',
    '--card-border-active': 'rgba(97, 242, 164, 0.42)',
    '--card-completed': '#0A2238',
    '--card-foreground': '#E3F9FF',
    '--card-glow': 'rgba(97, 242, 164, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#04172B',
    '--foreground': '#E3F9FF',
    '--hold-fill': '#61F2A4',
    '--input': '#1E4B6E',
    '--modal-bg': '#04172B',
    '--modal-border': '#1E4B6E',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--muted': '#1E4B6E',
    '--muted-foreground': '#B8ECFF',
    '--nav-active': '#61F2A4',
    '--nav-bg': '#0C2942',
    '--popover': '#0C2942',
    '--popover-foreground': '#E3F9FF',
    '--primary': '#61F2A4',
    '--primary-foreground': '#04172B',
    '--ring': '#61F2A4',
    '--secondary': '#1E4B6E',
    '--secondary-foreground': '#E3F9FF',
    '--streak': '#61F2A4',
    '--success': '#22c55e',
    '--success-foreground': '#04172B',
    '--xp': '#61F2A4',
    '--xp-bg': '#0C2942'
  },
  resolvedVars: {
    '--accent': '#6ACBFF',
    '--accent-foreground': '#04172B',
    '--accent-foreground-hsl': '211 83% 9%',
    '--accent-foreground-oklch': 'from #04172B l c h',
    '--accent-hsl': '201 100% 71%',
    '--accent-oklch': 'from #6ACBFF l c h',
    '--background': '#04172B',
    '--background-hsl': '211 83% 9%',
    '--background-oklch': 'from #04172B l c h',
    '--border': '#1E4B6E',
    '--border-hsl': '206 57% 27%',
    '--border-oklch': 'from #1E4B6E l c h',
    '--border-w': '1px',
    '--card': '#0C2942',
    '--card-border-active': 'rgba(97, 242, 164, 0.42)',
    '--card-completed': '#0A2238',
    '--card-completed-hsl': '209 70% 13%',
    '--card-completed-oklch': 'from #0A2238 l c h',
    '--card-foreground': '#E3F9FF',
    '--card-foreground-hsl': '193 100% 95%',
    '--card-foreground-oklch': 'from #E3F9FF l c h',
    '--card-glow': 'rgba(97, 242, 164, 0.10)',
    '--card-hsl': '208 69% 15%',
    '--card-oklch': 'from #0C2942 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#04172B',
    '--destructive-foreground-hsl': '211 83% 9%',
    '--destructive-foreground-oklch': 'from #04172B l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E3F9FF',
    '--foreground-hsl': '193 100% 95%',
    '--foreground-oklch': 'from #E3F9FF l c h',
    '--hold-fill': '#61F2A4',
    '--hold-fill-hsl': '148 85% 66%',
    '--hold-fill-oklch': 'from #61F2A4 l c h',
    '--input': '#1E4B6E',
    '--input-hsl': '206 57% 27%',
    '--input-oklch': 'from #1E4B6E l c h',
    '--modal-bg': '#04172B',
    '--modal-bg-hsl': '211 83% 9%',
    '--modal-bg-oklch': 'from #04172B l c h',
    '--modal-border': '#1E4B6E',
    '--modal-border-hsl': '206 57% 27%',
    '--modal-border-oklch': 'from #1E4B6E l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--muted': '#1E4B6E',
    '--muted-foreground': '#B8ECFF',
    '--muted-foreground-hsl': '196 100% 86%',
    '--muted-foreground-oklch': 'from #B8ECFF l c h',
    '--muted-hsl': '206 57% 27%',
    '--muted-oklch': 'from #1E4B6E l c h',
    '--nav-active': '#61F2A4',
    '--nav-active-hsl': '148 85% 66%',
    '--nav-active-oklch': 'from #61F2A4 l c h',
    '--nav-bg': '#0C2942',
    '--nav-bg-hsl': '208 69% 15%',
    '--nav-bg-oklch': 'from #0C2942 l c h',
    '--popover': '#0C2942',
    '--popover-foreground': '#E3F9FF',
    '--popover-foreground-hsl': '193 100% 95%',
    '--popover-foreground-oklch': 'from #E3F9FF l c h',
    '--popover-hsl': '208 69% 15%',
    '--popover-oklch': 'from #0C2942 l c h',
    '--primary': '#61F2A4',
    '--primary-foreground': '#04172B',
    '--primary-foreground-hsl': '211 83% 9%',
    '--primary-foreground-oklch': 'from #04172B l c h',
    '--primary-hsl': '148 85% 66%',
    '--primary-oklch': 'from #61F2A4 l c h',
    '--radius': '12px',
    '--ring': '#61F2A4',
    '--ring-hsl': '148 85% 66%',
    '--ring-oklch': 'from #61F2A4 l c h',
    '--secondary': '#1E4B6E',
    '--secondary-foreground': '#E3F9FF',
    '--secondary-foreground-hsl': '193 100% 95%',
    '--secondary-foreground-oklch': 'from #E3F9FF l c h',
    '--secondary-hsl': '206 57% 27%',
    '--secondary-oklch': 'from #1E4B6E l c h',
    '--shadow-card': '0 14px 36px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--shadow-card-active': '0 16px 40px color-mix(in srgb, var(--primary) 12%, transparent)',
    '--streak': '#61F2A4',
    '--streak-hsl': '148 85% 66%',
    '--streak-oklch': 'from #61F2A4 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#04172B',
    '--success-foreground-hsl': '211 83% 9%',
    '--success-foreground-oklch': 'from #04172B l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(148 85% 66% / 0.15)',
    '--xp': '#61F2A4',
    '--xp-bg': '#0C2942',
    '--xp-bg-hsl': '208 69% 15%',
    '--xp-bg-oklch': 'from #0C2942 l c h',
    '--xp-hsl': '148 85% 66%',
    '--xp-oklch': 'from #61F2A4 l c h'
  }
}
